import React from 'react';
import img01 from '../assests/img/img-001.jpg';
import img02 from '../assests/img/img-002.jpg';
import img03 from '../assests/img/img-003.jpg';
import img04 from '../assests/img/img-004.jpg';
import img05 from '../assests/img/img-005.jpg';
import img06 from '../assests/img/img-006.jpg';

const setImages = [
  { image: img01, name: 'Royal Palace Set' },
  { image: img02, name: 'Elinor Courtyard Set' },
  { image: img03, name: 'Wooden Villa Set' },
  { image: img04, name: 'Cocoa Cafe Set' },
  { image: img05, name: 'Floral Street Set' },
  { image: img06, name: 'Blue House Set' },
];

function Showact() {
  return (
    <section className="our-sets-section" id="our-sets-section">
      <div className="container">
        <div className="our-sets-heading">
          <span>Picture Valley</span>
          <h2>Our Sets</h2>
        </div>

        <div className="our-sets-grid">
          {setImages.map((set) => (
            <article className="our-set-card" key={set.name}>
              <img src={set.image} alt={set.name} />
              <div className="our-set-overlay">
                <h3>{set.name}</h3>
              </div>
            </article>
          ))}
        </div>
      </div>
    </section>
  );
}

export default Showact;
